
import { toast, Zoom } from "react-toastify";

export function confirmToast({
  title = "Confirm delete",
  message = "This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  toastId = "confirm-delete",
  theme = "colored",
    isLoading = false, 
} = {}) {
  return new Promise((resolve) => {
    const ConfirmUI = () => (
      <div className="ct-container">
        <strong className="ct-title">{title}</strong>
        <div className="ct-message">{message}</div>
        <div className="ct-actions">
          <button
            type="button"
            className="ct-btn ct-btn-cancel"
            onClick={() => {
              toast.dismiss(toastId);
              resolve(false);
            }}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="ct-btn ct-btn-danger"
            onClick={() => {
              toast.dismiss(toastId);
              resolve(true);
            }}
            disabled={isLoading}
          >
            {confirmText}
          </button>
        </div>
      </div>
    );

    toast(<ConfirmUI />, {
      toastId,
      position: "top-right",
      autoClose: false,   // wait for a choice
      closeOnClick: false,
      closeButton: false,
      draggable: false,
      transition: Zoom,
      theme,
    });
  });
}
